import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Form } from 'react-bootstrap';
import { getRequestNoParams, postRequest } from './Services/HttpClient';
import './App.css';

const Krudantha = () => {
  const [upasargaList, setUpasargaList] = useState([]);
  const [dhatuList, setDhatuList] = useState([]);
  const [krutPratyayaList, setKrutPratyayaList] = useState([]);
  
  const [selectedVisarga, setSelectedVisarga] = useState('');
  const [selectedDhatu, setSelectedDhatu] = useState('');
  const [selectedKrut, setSelectedKrut] = useState('');
  const [selectedContext, setSelectedContext] = useState('');

  const [rupa, setRupa] = useState('');
  const [meaning, setMeaning] = useState('');
  const [process, setProcess] = useState('');

  useEffect(() => {
    fetchUpasarga();
    fetchDhatu();
    fetchKrutPratyaya();
  }, []);

  const fetchUpasarga = async () => {
    try {
      const data = await getRequestNoParams('getupsargalist');
      console.log("Fetched upasarga list:", data.keys); 
      setUpasargaList(data.keys);
    } catch (error) {
      console.error("Error fetching upasarga:", error);
    }
  };

  const fetchDhatu = async () => {
    try {
      const data = await getRequestNoParams('getdhatuslist');
      console.log("Fetched dhatu list:", data.keys); 
      setDhatuList(data.keys);
    } catch (error) {
      console.error("Error fetching dhatu:", error);
    }
  };

const fetchKrutPratyaya = async () => {
  try {
    const data = await getRequestNoParams('getkrudantalist');
    console.log("Fetched krut pratyaya list:", data.keys); 
    setKrutPratyayaList(data.keys);
  } catch (error) {
    console.error("Error fetching krut pratyaya:", error);
  }
};

  const selectVisarga = (e) => {
    setSelectedVisarga(e.target.value);
  };

  const selectDhatu = (e) => {
    setSelectedDhatu(e.target.value);
  };

  const selectKrut = (e) => {
    setSelectedKrut(e.target.value);
  };

  const selectContext = (e) => {
    setSelectedContext(e.target.value);
  };

  const generateRupa = async () => {
    try {
      const payload = {
        upasarga: selectedVisarga,
        dhatu: selectedDhatu,
        krutPratyaya: selectedKrut,
      };
  
      console.log("Sending POST request with:", payload);
  
      const response = await postRequest('generateRupa', JSON.stringify(payload), {
        headers: {
          'Content-Type': 'application/json'
        }
      });
  
      if (response.ok) {
        const data = await response.json();
        console.log("Response from backend:", data);
  
        if (data && data.data) {
          setRupa(data.data.Rupa || '');  
          setMeaning(data.data.Meaning || '');
          setProcess(data.data.Process || '');
        } else {
          console.error("Unexpected data structure", data);
        }
      } else {
        throw new Error('Failed to generate rupa');
      }
    } catch (error) {
      console.error("Error generating Rupa:", error);
    }
  };  
  
  return (
    <Container fluid="md">
      <div>
        <Row className="text-center mb-4">
          <h2><strong>Krudanta Generator</strong></h2>
        </Row>
        
        <Row className="mb-3">
          <Col md={12} lg={3} className="mb-3 mb-lg-0 d-flex justify-content-center">
            <div className="krudanta-dropdown-container">
              <h5 className='text-center'><strong>उपसर्गः Upasarga</strong></h5>
              <Form.Select onChange={selectVisarga} className="krudantha-select">
                <option value="">Select</option>
                {upasargaList.map((item, idx) => (
                  <option key={idx} value={item}>{item}</option>
                ))}
              </Form.Select>
            </div>
          </Col>
          <Col md={12} lg={3} className="mb-3 mb-lg-0 d-flex justify-content-center">
            <div className="krudanta-dropdown-container">
              <h5 className='text-center'><strong>धातुः Dhatu</strong></h5>
              <Form.Select onChange={selectDhatu} className="krudantha-select">
                <option value="">Select</option>
                {dhatuList.map((item, idx) => (
                  <option key={idx} value={item}>{item}</option>
                ))}
              </Form.Select>
            </div>
          </Col>
          <Col md={12} lg={3} className="mb-3 mb-lg-0 d-flex justify-content-center">
            <div className="krudanta-dropdown-container">
              <h5 className='text-center'><strong>कृत् प्रत्ययः Krut Pratyaya</strong></h5>
              <Form.Select onChange={selectKrut} className="krudantha-select">
                <option value="">Select</option>
                {krutPratyayaList.map((item, idx) => (
                  <option key={idx} value={item}>{item}</option>
                ))}
              </Form.Select>
            </div>
          </Col>
          <Col md={12} lg={3} className="d-flex justify-content-center">
            <div className="krudanta-dropdown-container">
              <h5 className='text-center'><strong>अभिप्रायः Context</strong></h5>
              <Form.Select onChange={selectContext} className="krudantha-select">
                <option value="">Select</option>
                <option value="अभिप्रायः">अभिप्रायः</option>
              </Form.Select>
            </div>
          </Col>
        </Row>
        <Row className="mb-3 mt-4">
          <Col className="d-flex justify-content-center">
            <input
              id='display-button'
              type='submit'
              value='जनय Generate Rupa'
              onClick={generateRupa}
              className='krudantha-button'
            />
          </Col>
        </Row>
        <Row className="mb-3 krudantha-centered-row">
          <Col md={4} className="krudantha-centered-text">
            <h5><strong>रूपम् Rupa : </strong></h5>
          </Col>
          <Col md={8}>
            <textarea value={rupa} rows="3" className="krudantha-textarea"></textarea>
          </Col>
        </Row>
        <Row className="mb-3 krudantha-centered-row">
          <Col md={4} className="krudantha-centered-text">
            <h5><strong>अर्थः Meaning : </strong></h5>
          </Col>
          <Col md={8}>
            <textarea value={meaning} rows="3" className="krudantha-textarea"></textarea>
          </Col>
        </Row>
        <Row className="mb-3 krudantha-centered-row">
          <Col md={4} className="krudantha-centered-text">
            <h5><strong>प्रक्रिया Process : </strong></h5>
          </Col>
          <Col md={8}>
            <textarea value={process} rows="3" className="krudantha-textarea"></textarea>
          </Col>
        </Row>
        <Row className="mt-3">
          <Col className="d-flex flex-wrap justify-content-center">
            <input
              id='display-button'
              type='submit'
              value='अन्यो धातुः  Another Dhatu'
              onClick={generateRupa}
              className='krudantha-button'
            />
            <input
              id='display-button'
              type='submit'
              value='अन्यः प्रत्ययः  New Pratyaya'
              onClick={generateRupa}
              className='krudantha-button'
            />
            <input
              id='display-button'
              type='submit'
              value='अङ्का Score'
              onClick={generateRupa}
              className='krudantha-button'
            />
          </Col>
        </Row>
      </div>
    </Container>
  );
};

export default Krudantha;
